function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#94C11F",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "M2 20L10 20 10.209 28.245",
  transform: "translate(-1033 -249) translate(1034.762 251.437) rotate(-150 6.105 24.122)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.804 24.467c14.116 17.394 28.171 26.52 44.654 28.999 10.989 1.652 28.45-.287 52.38-5.818",
  transform: "translate(-1033 -249) translate(1034.762 251.437) scale(1 -1) rotate(-33 -80.19 0)"
}))));

var SvgArrowOverviewMd3 = function SvgArrowOverviewMd3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 83,
    viewBox: "0 0 105 83",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowOverviewMd3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrowOverviewMd3.660f97e9.svg";
export { ForwardRef as ReactComponent };